import React, { useEffect, useState, Fragment } from 'react';
import { TableContentForStatusType } from '../../../Common/Table/tableContent';
import $ from 'jquery';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import services from '../../services';
import { CommonEncryptParam } from '../../../../../utils/CommonParams';
import { useHistory } from 'react-router';

const screenCode = 'PURCHASEORDER';

export function ApproveSupplierListing(props) {

    let history = useHistory();
    const { searchData, permission } = props;
    const [isTableHide, setIsTableHide] = useState(true);
    const contentRowNames = ["orderNumber", "dueDate", "invoiceDate", "buyerName", "statusTypeID"]
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false
    });
    const [data, setData] = useState([]);
    const [isAuthorized, setIsAuthorized] = useState(true);

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getOrdersForSupplierVerify()
        )
    }, [searchData.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUPPLIERVERIFY');

        if (isAuthorized === undefined) {
            setIsAuthorized(false);
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDSUPPLIERVERIFY');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
        });
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable({
            "order": []
        });
    }

    function handleClick(purchaseAdvice) {
        history.push({
            pathname: 'purchaseAdvice/approveSuppliers/' + CommonEncryptParam(purchaseAdvice.orderID.toString()),
            data: purchaseAdvice,
            edit: true
        })
    }

    async function getOrdersForSupplierVerify() {
        var result = await services.getOrdersForSupplierVerify(searchData.operationEntityID);

        var duplicateRecords = [];
        var unique = result.filter((v, i, a) => a.findIndex(t => (t.orderNumber === v.orderNumber)) === i);

        result.forEach(x => {
            var isDuplicate = duplicateRecords.find(y => y.orderNumber === x.orderNumber);

            if (!isDuplicate) {
                duplicateRecords.push({ orderNumber: x.orderNumber, count: 1 });
            } else {
                isDuplicate.count++;
            }
        });

        unique.forEach(x => {
            var result = duplicateRecords.find(y => y.orderNumber === x.orderNumber);

            if (result.count >= 2) {
                x.statusTypeID = 7;
            }
        });

        destroyDataTable();
        setData(unique);
        createDataTable();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            {
                isAuthorized ?
                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive row-top-gap">
                                <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Order Number</th>
                                            <th>Due Date</th>
                                            <th>Invoice Date</th>
                                            <th>Buyer</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContentForStatusType
                                            data={data}
                                            hasEdit={permissionList.isAddEditEnabled}
                                            contentRowNames={contentRowNames}
                                            handleClick={handleClick}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    : <p>You are unauthorized to access this page!</p>
                }
        </Fragment>
    )
}